import { render, staticRenderFns } from "./HotelFooter.vue?vue&type=template&id=07a0f84c&scoped=true&"
import script from "./HotelFooter.vue?vue&type=script&lang=js&"
export * from "./HotelFooter.vue?vue&type=script&lang=js&"
import style0 from "./HotelFooter.vue?vue&type=style&index=0&id=07a0f84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a0f84c",
  null
  
)

export default component.exports